var _defs, _rect, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 5.2 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "te",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4d4d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9a9a9a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tc",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9a9a9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#ededed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a5a5a5"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 26,
    width: 44,
    height: 25,
    fill: "#6e6e6e"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "url(#tc)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 26,
    width: 7,
    height: 25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.3,
    y: 26,
    width: 7,
    height: 25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.7,
    y: 26,
    width: 7,
    height: 25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 26,
    width: 7,
    height: 25
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "url(#te)",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 22 L32 7 L59 22Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 22,
    width: 54,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 51,
    width: 54,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 56,
    width: 60,
    height: 5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemple);
export default __webpack_public_path__ + "static/media/temple.dacd1efd039759de489abe936736dfc7.svg";
export { ForwardRef as ReactComponent };